export const handleChangeInputReferalPage = (name, value) => ({
    type: 'CHANGE_INPUT_PAGE_REFERAL', name, value
});

export const handleChangeLoaderPageReferal = (isLoading) => ({
    type: 'CHANGE_LOADER_PAGE_REFERAL', isLoading
});

export const handleChangeDisabledBtnPageReferal = (disabledBtn) => ({
    type: 'CHANGE_DISABLE_BTN_PAGE_REFERAL', disabledBtn
});

export const handleChangeBtnClassPageReferal = (className) => ({
    type: 'CHANGE_BTN_CLASS_PAGE_REFERAL', className
});